import styled from "styled-components";

export const FormStyle = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 800px;
  background-color: rgba(14, 220, 235, 0.6);
  border-radius: 10px;
  align-items: center;
  margin: 20px auto;
  padding: 20px 100px;
  @media (max-width: 1024px) {
    max-width: 350px;
  }
`;

export const InputStyle = styled.input`
  padding: 15px;
  width: 100%;
`;

export const TextArea = styled.textarea`
  padding: 15px;
  width: 100%;
  height: 200px;
`;
